
var customerId = window.ShopifyCustomerId;
var fieldId = 5950;
var permissionGrantedRejectedWebPush = false;
var permissionGrantedWebPush = false;
var isSubscribedStatus = false;
var isGeneralSubscribe = false;

const POPUP_KEY = 'subscribePopupDismissedAt';
const POPUP_DELAY_DAYS = 3;

function handleLightboxDisplayAndEvents() {
  const laterBtn = document.getElementById('wp-btn-later');
  const subscribeBtn = document.getElementById('wp-btn-subscribe');
  const closeBtn = document.getElementById('wp-subscribe-close');

  function displayIfExists(id, display = 'none') {
    const element = document.getElementById(id);
    if (element) element.style.display = display;
  }


  laterBtn?.addEventListener('click', function () {
    displayIfExists('wp-subscribe-lightbox');
    displayIfExists('wp-lightbox-mask');
    localStorage.setItem(POPUP_KEY, Date.now().toString());
    displayIfExists('wp-lightbox-mask', 'none');
  });

  closeBtn?.addEventListener('click', function () {
    displayIfExists('wp-subscribe-success');
    displayIfExists('wp-lightbox-mask');
    displayIfExists('wp-lightbox-mask', 'none');
  });

  subscribeBtn?.addEventListener('click', function () {
    generalSubscribe();
    displayIfExists('wp-subscribe-lightbox');
    displayIfExists('wp-lightbox-mask', 'none');
  });

  displayIfExists('wp-subscribe-lightbox', 'block');
  displayIfExists('wp-lightbox-mask', 'block');
}


function generalSubscribe() {
  WebEmarsysSdk.push(() => {
    isGeneralSubscribe = true;
    WebEmarsysSdk.subscribe();

    WebEmarsysSdk.push([
      'onSubscribe',
      () => {
        localStorage.setItem('emarsysSubscribe', 'subscribe');
        displayIfExists('wp-subscribe-success', 'block');

        if (customerId) {
          handleSubscribe('login');
        }
      },
    ]);
  });
}

function isIOS() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
}

function isStandaloneWebApp() {
  return window.matchMedia('(display-mode: standalone)').matches;
}

function handleSubscribe(status) {
  const contactInfo = {
    fieldId: Number(fieldId),
    fieldValue: customerId,
  };

  WebEmarsysSdk.push(() => {
    WebEmarsysSdk.isSubscribed()
      .then(() => {
        if (status === 'login') {
          WebEmarsysSdk.login(contactInfo).then((res) => {
            console.log('Login Result:', res);
            if (res) localStorage.setItem('emarsysLogin', 'login');
          });
        } else if (status === 'logout') {
          WebEmarsysSdk.logout().then((res) => {
            console.log('Logout Result:', res);
            if (res) localStorage.removeItem('emarsysLogin');
          });
        }
      })
      .catch((err) => console.error('Is subscribed error', err));
  });
}

function funcHTMLPopup() {
  if (permissionGrantedWebPush && !isSubscribedStatus) {
    WebEmarsysSdk.subscribe();
    console.log('Resubscribe: WebEmarsysSdk.subscribe()');
  }
  if (!permissionGrantedRejectedWebPush && shouldShowPopup()) {
    handleLightboxDisplayAndEvents();
  }
}

function shouldShowPopup() {
  const lastDismissed = localStorage.getItem(POPUP_KEY);
  if (!lastDismissed) return true;

  const lastTime = new Date(parseInt(lastDismissed));
  const now = new Date();
  const diffInDays = (now - lastTime) / (1000 * 60 * 60 * 24);
  return diffInDays >= POPUP_DELAY_DAYS;
}

if (!isIOS() || isStandaloneWebApp()) {
  WebEmarsysSdk.push([
    'onReady',
    () => {
      WebEmarsysSdk.push([
        'onPermissionGranted',
        () => {
          console.log('EVENT: onPermissionGranted');
          if (!localStorage.getItem('emarsysSubscribe') && !isGeneralSubscribe) {
            console.log('Existing subscriber: web push migration');
            WebEmarsysSdk.subscribe();
            localStorage.setItem('emarsysSubscribe', 'subscribe');
          }
          permissionGrantedRejectedWebPush = true;
          permissionGrantedWebPush = true;
        },
      ]);
      WebEmarsysSdk.push([
        'onPermissionDenied',
        () => {
          console.log('EVENT: onPermissionDenied');
          permissionGrantedRejectedWebPush = true;
        },
      ]);
      WebEmarsysSdk.isSubscribed()
        .then((e) => {
          isSubscribedStatus = e;
        })
        .catch(() => {});
      //Since above asynchronous function may take time to call back, it setup to wait for 2 seconds to the next logic.
      setTimeout(funcHTMLPopup, 2000);
    },
  ]);
}

if (customerId) {
  if (!localStorage.getItem('emarsysLogin')) {
    handleSubscribe('login');
  }
} else {
  if (localStorage.getItem('emarsysLogin')) {
    handleSubscribe('logout');
  }
}
